import { OptionTuple } from '~/components/Input/Select/Select';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { insertOnCondition } from '~/utils/array';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & {
  disableAllOption?: boolean;
};

function SexFilterSelectElement<TFormState extends BaseFormState>(
  { disableAllOption = false, ...props }: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const options: OptionTuple[] = [
    ...insertOnCondition<OptionTuple>(['Alla kön', 'ALL'], !disableAllOption),
    ['Dam', 'F'],
    ['Herr', 'M'],
  ];

  return <Input.Select options={options} ref={ref} aria-label={props['aria-label'] ?? 'Kön'} {...props} />;
}

export const SexFilterSelect = forwardRef(SexFilterSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof SexFilterSelectElement>;
